import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { DeliveryRoute } from "@/widgets/delivery-route/ui";
import { Box, Stack } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";
import type { PreviewContractProposalOfferCargo } from "../../model";
export const DestinationsInfo = ({
  deliveryProposalOfferCargo,
  contractProposalOfferCargo,
}: {
  deliveryProposalOfferCargo: FreightMatching.schemas.OfferCargo;
  contractProposalOfferCargo: PreviewContractProposalOfferCargo;
}) => {
  return (
    <BaseHeaderWrapper title="配送ルート">
      <Stack spacing={5} maxWidth="628px">
        <Box
          position="relative"
          padding="24px 16px"
          border="1px solid"
          borderColor="grey.200"
          borderRadius="16px"
        >
          <DeliveryRoute baseOfferCargo={contractProposalOfferCargo} />
        </Box>
        {deliveryProposalOfferCargo.attachedDestinationFiles && (
          <BaseKeyValue keyLabel="添付ファイル">
            {deliveryProposalOfferCargo.attachedDestinationFiles.map((file) => (
              <Box key={file.url}>{file.filename}</Box>
            ))}
          </BaseKeyValue>
        )}
      </Stack>
    </BaseHeaderWrapper>
  );
};
